export * from './chrome-picker-selector';
export * from './input-color';

export * from './color-picker.component';
export * from './color-picker.module';
